export const notificationTypes = {
  NOTIFY                  : "@NOTIFICATION/NOTIFY",
  CLEAR_NOTIFICATION_DATA : "@NOTIFICATION/CLEAR_NOTIFICATION_DATA",
};

export interface NotificationI {
  type: "info" | "warning" | "success" | "error";
  message: string;
}

export interface NotificationStateI {
  notification: NotificationI;
}

export interface Notify {
  type: typeof notificationTypes.NOTIFY;
  payload: NotificationI;
}

export interface ClearNotificationData {
  type: typeof notificationTypes.CLEAR_NOTIFICATION_DATA;
  payload: NotificationI;
}

export type getNotificationTypes = Notify | ClearNotificationData
